export interface IMenu {
  Id: string;
  Level: number;
  Name: string;
  ParentId?: string | any;
  Url?: string | any;
  Img?: string | any;
  Seq: number;
  Children?: IMenu[];
}

const menus: IMenu[] = [
  {
    Id: "1",
    Level: 1,
    Name: "基础数据",
    Img: "mdi-language-html5",
    Seq: 1,
    Children: [
      {
        Id: "11",
        Level: 2,
        Name: "物料",
        Seq: 11,
        ParentId: "1",
        Url: "/pc/pub/material/material"
      },
      {
        Id: "12",
        Level: 2,
        Name: "菜单",
        Seq: 12,
        ParentId: "1",
        Url: "/app/menu/menu"
      }
    ]
  }
];

export { menus };
